import CheckboxDropdown from './CheckboxDropdown';
import { withFormMeta } from '../../FormMeta';
import { wrapInLabel } from '../NewInputLabelWrapper';

export default withFormMeta(wrapInLabel(CheckboxDropdown));
